import { parseApiDateTime } from 'src/utils/parseApiDateTime';

// Minutes either side of the appointment during which staff may open the
// consultation console from the lead detail page. Joining early is deliberate
// (the practitioner sets up before the patient arrives) and the tail keeps a
// late-running consultation reachable.
export const JOIN_OPENS_MINUTES_BEFORE = 15;
export const JOIN_CLOSES_MINUTES_AFTER = 30;
export const DEFAULT_DURATION_MINUTES = 30;

// The lead-detail appointment feed sends the legacy `DD-MM-YYYY HH:mm:ss.0Z`
// string. That trailing 'Z' is a literal character in Django's
// `DATETIME_FORMAT`, not a UTC marker: the backend's `DATETIME_INPUT_FORMATS`
// treat the value as NAIVE Europe/London wall-clock time. Parsing it as the
// viewer's local time (what a bare `moment(value, 'DD-MM-YYYY HH:mm:ss')` does)
// put the join window an hour out for anyone whose browser is not on UK time,
// and parsing it as UTC would put it an hour out for every UK user through BST.
//
// `parseApiDateTime` is the repo's canonical resolution of exactly that shape:
// it reinterprets the legacy string in `Europe/London` through dayjs's IANA
// database, so the BST/GMT offset is correct on both sides of a clock change,
// while genuine ISO-8601 instants (the PMS diary feeds) keep the offset they
// actually carry.
export const parseAppointmentStart = (value) => {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value !== 'string' || !value.trim()) return null;
  const parsed = parseApiDateTime(value);
  return parsed && parsed.isValid() ? parsed.toDate() : null;
};

// consoleUrl only forwards a string start; anything unparseable travels as
// nothing rather than as a bad query value.
export const appointmentStartIso = (value) => {
  const start = parseAppointmentStart(value);
  return start ? start.toISOString() : null;
};

export const isWithinJoinWindow = (value, durationMinutes, now = new Date()) => {
  const start = parseAppointmentStart(value);
  if (!start) return false;
  const duration = Number(durationMinutes) > 0 ? Number(durationMinutes) : DEFAULT_DURATION_MINUTES;
  const at = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(at)) return false;
  return (
    at >= start.getTime() - JOIN_OPENS_MINUTES_BEFORE * 60000 &&
    at <= start.getTime() + (duration + JOIN_CLOSES_MINUTES_AFTER) * 60000
  );
};
